import { useEffect, useState } from "react";
import FileUploadZone, { UploadedFile } from "@/components/FileUploadZone";
import FileList from "@/components/FileList";
import RecentLinks from "@/components/RecentLinks";
import Navbar from "@/components/Navbar";
import { getRecentShares } from "@/services/share-service";
import { toast } from "sonner";
import LoadingSpinner from "@/components/LoadingSpinner";

const Index = () => {
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [recentShares, setRecentShares] = useState([]);

  const clearUploadedFiles = () => {
    setUploadedFiles([]);
  };

  const handleFilesUploaded = (newFiles: UploadedFile[]) => {
    setUploadedFiles((prev) => [...prev, ...newFiles]);
  };

  const loadRecentShares = async () => {
    try {
      const shares = await getRecentShares();
      setRecentShares(
        shares.map((share) => ({
          ...share,
          url: `${window.location.origin}/share/${share.id}`,
          createdAt: new Date(share.createdAt),
          expiresAt: share.expiresAt ? new Date(share.expiresAt) : undefined,
        }))
      );
    } catch (error) {
      toast.error("Failed to load recent shares");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadRecentShares();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <main className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div className="space-y-6">
          <div className="bg-white rounded-lg shadow">
            <div className="p-6">
              <FileUploadZone onFilesUploaded={handleFilesUploaded} />
              <FileList
                clearUploadedFiles={clearUploadedFiles}
                loadRecentShares={loadRecentShares}
                files={uploadedFiles}
              />
            </div>
          </div>

          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <RecentLinks links={recentShares} />
          )}
        </div>
      </main>
    </div>
  );
};

export default Index;
